<template>
<div class="content">
  <div class="header">
    <el-button @click="setRent">保存</el-button>
    <el-button v-if="from_data.is_ceased" @click="setComponents('CustomerRentChange')">转/退租</el-button>
    <el-button @click="goHistory">历史出租记录</el-button>
<!--    <el-button v-if="from_data.id" @click="toSaleCarryOver">账单结转</el-button>-->
    <el-button @click="setComponents('CustomerRentMain')">返回</el-button>
  </div>
  <div class="body">
    <el-descriptions size="mini" direction="vertical" :column="1" border>
      <el-descriptions-item label="房产出租详细信息">
        <el-descriptions size="mini" :column="2" border>
          <el-descriptions-item label="房产">
            {{from_data.house_name}}
          </el-descriptions-item>
          <el-descriptions-item label=""></el-descriptions-item>
          <el-descriptions-item label="业主名称">
            <el-input size="mini" v-model="from_data.customer_name" readonly></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="承租人名称">
            <div>
              <el-input v-model="from_data.rent_customer_name" readonly style="width: 200px"></el-input>
              <el-button v-if="!from_data.id" size="mini" @click="selectUser">选择客户</el-button>
<!--              <el-button v-if="!from_data.id" size="mini" icon="el-icon-user-solid" circle title="新增客户" @click="addCustomer(1)"></el-button>-->
<!--              <el-button v-if="!from_data.id" size="mini" icon="el-icon-s-home" circle title="新增企业" @click="addCustomer(2)"></el-button>-->

              <el-button v-if="from_data.rent_customer_id" size="mini" :icon="show_customer?'el-icon-folder-opened':'el-icon-folder'" circle title="租户明细" @click="show_customer=!show_customer"></el-button>
            </div>
            <div v-if="from_data.rent_customer_id">
              <el-checkbox v-model="from_data.is_change_house_charge_standard_customer" :true-label="1" :false-label="0">修改收费对象</el-checkbox>
            </div>
          </el-descriptions-item>

          <el-descriptions-item v-if="show_customer" label="客户类型">
            <el-checkbox-group style="width: 300px" v-model="from_data.rent_customer_type">
              <el-checkbox label="1">业主</el-checkbox>
              <el-checkbox label="2">租户</el-checkbox>
              <el-checkbox label="3">住户</el-checkbox>
              <el-checkbox label="4">共有人</el-checkbox>
              <el-checkbox label="5">开发商</el-checkbox>
              <el-checkbox label="9">其它</el-checkbox>
            </el-checkbox-group>
          </el-descriptions-item>
<!--          <el-descriptions-item v-if="show_customer" label="所属部门">-->
<!--            <el-input v-model="from_data.rent_customer_organization" readonly style="width: 200px"></el-input>-->
<!--          </el-descriptions-item>-->
          <el-descriptions-item v-if="show_customer" label="证件类型">
<!--            <el-input v-model="from_data.credentials_type" readonly style="width: 200px"></el-input>-->

            <el-select v-model="from_data.credentials_type" filterable placeholder="请选择">
              <el-option v-for="item in credentialsList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item v-if="show_customer" label="证件号码">
            <el-input v-model="from_data.rent_customer_name" readonly style="width: 200px"></el-input>
          </el-descriptions-item>
          <el-descriptions-item v-if="show_customer" label="性别">
<!--            <el-input v-model="from_data.rent_customer_sex" readonly style="width: 200px"></el-input>-->
            <el-radio v-model="from_data.sex" label="1">男</el-radio>
            <el-radio v-model="from_data.sex" label="2">女</el-radio>
          </el-descriptions-item>
          <el-descriptions-item v-if="show_customer" label="	出生日期">
            <el-input v-model="from_data.birthday" readonly style="width: 200px"></el-input>
          </el-descriptions-item>
<!--          <el-descriptions-item v-if="show_customer" label="家庭电话">-->
<!--            <el-input v-model="from_data.rent_customer_name" readonly style="width: 200px"></el-input>-->
<!--          </el-descriptions-item>-->
          <el-descriptions-item v-if="show_customer" label="手机">
            <el-input v-model="from_data.rent_customer_name" readonly style="width: 200px"></el-input>
          </el-descriptions-item>
          <el-descriptions-item v-if="show_customer" label="家庭地址">
            <el-input v-model="from_data.home_addresshome_address" readonly style="width: 200px"></el-input>
          </el-descriptions-item>
          <el-descriptions-item v-if="show_customer" label="紧急联系人">
            {{from_data.emergency_contact}} {{from_data.emergency_number}}
<!--            <el-input v-model="from_data.rent_customer_name" readonly style="width: 200px"></el-input>-->
          </el-descriptions-item>
<!--          <el-descriptions-item v-if="show_customer" label="单位名称">-->
<!--            <el-input v-model="from_data.rent_customer_name" readonly style="width: 200px"></el-input>-->
<!--          </el-descriptions-item>-->
<!--          <el-descriptions-item v-if="show_customer" label="单位地址">-->
<!--            <el-input v-model="from_data.rent_customer_name" readonly style="width: 200px"></el-input>-->
<!--          </el-descriptions-item>-->

          <el-descriptions-item label="合同编号">
            <el-input size="mini" v-model="from_data.contract_id" clearable></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="承租时间">
            <el-date-picker
              style="width: 150px"
              v-model="from_data.begin_date"
              size="mini"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="是否主房产">
            <el-checkbox :true-label="1" :false-label="0" label="(主房产用于邮寄帐单等)" v-model="from_data.is_main_house"></el-checkbox>
          </el-descriptions-item>
          <el-descriptions-item label="入住时间">
            <el-date-picker
              style="width: 150px"
              v-model="from_data.move_in_date"
              size="mini"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="入住人数">
            <el-input size="mini" v-model="from_data.person_count" clearable></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="退租时间">
            <el-date-picker
              style="width: 150px"
              v-model="from_data.cease_date"
              size="mini"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="用 途">
            <el-input size="mini" type="textarea" :rows="2" v-model="from_data.usage" clearable></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="安全管理">
            <el-input size="mini" type="textarea" :rows="2" v-model="from_data.security_remark" clearable></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="备 注">
            <el-input size="mini" type="textarea" :rows="2" v-model="from_data.remark" clearable></el-input>
          </el-descriptions-item>

          <el-descriptions-item label="附件">
<!--            <el-input size="mini" v-model="from_data.file_id" clearable></el-input>-->
            <el-link type="primary" v-if="from_data.file_id" @click="downloadFile(from_data.file_id)">下载附件</el-link>
            &nbsp;&nbsp;
            <el-link @click="UploadFile(data=>from_data.file_id=data.FileID)">上传附件</el-link>
          </el-descriptions-item>
        </el-descriptions>
      </el-descriptions-item>
    </el-descriptions>
  </div>
  <AddCustomerWindow ref="AddCustomerWindow" />
  <ErpRoomUser ref="ErpRoomUser" />
</div>
</template>

<script>
import ErpRoomUser from "../../../Common/ErpRoomUser";
import AddCustomerWindow from "../../../Common/AddCustomerWindow";
import Http from "../common/Http";

export default {
  name: "CustomerRentEditor",
  components:{ErpRoomUser, AddCustomerWindow},
  inject:["mainObj","setComponentsId"],
  data(){
    return{
      where:{
        id:"",
        house_id:"",
        house_name:"",
      },
      from_data:{
        id:"",
        customer_id:"",
        house_id:"",
        is_main_house:"",
        contract_id:"",
        rent_customer_id:"",
        begin_date:"",
        is_ceased:"",
        cease_date:"",
        cause:"",
        remark:"",
        new_address:"",
        new_contact_info:"",
        move_house_card:"",
        move_house_date:"",
        rent_contract_id:"",
        person_count:"",
        usage:"",
        move_in_date:"",
        sublet_date:"",
        security_remark:"",
        is_change_house_charge_standard_customer:1,
        file_id:"",
        is_merge:"",
        db_id:"",
        sub_id:"",
        op_user_id:"",
        rent_customer_type:[],
        customer_name:"",
        rent_customer_name:"",
        house_name:"",
        rent_customer_organization:"",
        rent_customer_sex:"",
        rent_customer_class:"",
        credentials_type:"",
        credentials_code:"",
        birthday:"",
        home_addresshome_address:"",
        contact_number:"",
        emergency_contact:"",
        emergency_number:""
      },
      show_customer:false,
      credentialsList: [{"value":"1","label":"居民身份证"},{"value":"11","label":"离休干部荣誉证"},{"value":"12","label":"护照"},{"value":"9","label":"文职干部证"},{"value":"6","label":"士兵证"},{"value":"8","label":"军官退休证"},{"value":"2","label":"临时身份证"},{"value":"15","label":"外国人永久居留证"},{"value":"16","label":"其他"},{"value":"13","label":"港澳台同胞来往通行证"},{"value":"10","label":"文职干部退休证"},{"value":"3","label":"户口簿"},{"value":"4","label":"军官证"},{"value":"5","label":"警官证"},{"value":"7","label":"军事学院证"},{"value":"14","label":"边民出入境通行证"},{"value":"17","label":"居民身份证（台）"}],
    }
  },
  activated() {
    this.where.house_id=this.house_id;
    this.where.house_name=this.house_name;
    this.where.rent_id=this.rent_id;
    this.getRent()
  },
  watch:{
    rent_id(n,o){
      this.where.id=n;
    },
    house_id(n,o){
      this.where.house_id=n;
    }
  },
  computed:{
    rent_id(){
      return this.mainObj.rent_id
    },
    house_name(){
      return this.mainObj.house_name
    },
    house_id(){
      return this.mainObj.house_id
    },
  },
  methods:{
    setComponents(componentsId){
      this.setComponentsId(componentsId)
    },
    getRent(){
      const that=this;
      let where=ERP.reJson(that.where)
      ERP.postRequest({url:"admin/HouseRent/getRent",data:where},ret=>{
        if(ret.code){
          let from_data=ret.data
          from_data.rent_customer_type=(from_data.rent_customer_type||'').split(",")
          that.from_data=from_data;
        }else{
          this.$msgbox.alert(ret.msg||"查询失败")
        }
      })
    },
    setRent(){
      const that=this;
      let data=ERP.reJson(that.from_data)
      if(!data.rent_customer_id){
        that.$message.error('请选择承租人');
        return false;
      }
      that.mainObj.now_customer_id=data.customer_id;
      that.mainObj.new_customer_id=data.rent_customer_id;
      ERP.postRequest({url:"admin/HouseRent/setRent",data:data},ret=>{
        if(ret.code){
          that.$message.success("保存成功")
          // console.log(data);
          if(!(data.id>0)){
            that.$message.success("设置成功")
            // that.$confirm('当前的租户已经保存成功，下一步将跳转进行账单结转！', '提示', {
            //   confirmButtonText: '下一步',
            //   cancelButtonText: '取消',
            //   type: 'warning'
            // }).then(() => {
            //   that.setComponents("SaleCarryOver")
            // }).catch(() => {
            //   that.$message.error('您当前放弃了账单结转')
            // });
          }
          that.getRent();
        }else{
          this.$msgbox.alert(ret.msg||"设置失败")
        }
      })
    },
    addCustomer(type=1){
      const that=this;
      that.$refs.AddCustomerWindow.show(type,data=>{
        that.from_data.rent_customer_id=data.customer_id;
        that.from_data.rent_customer_name=data.name;
        that.$forceUpdate()
      })
    },
    selectUser(){
      const that=this;
      that.$refs.ErpRoomUser.show(data=>{
        that.from_data.rent_customer_id=data.id;
        that.from_data.rent_customer_name=data.name;
      },"")
    },
    UploadFile(callback) {
      Http.uploadFile2(callback)
    },
    downloadFile(id=0,callback) {
      __OSS__.getXscFile(id,ret=>{
        // console.log(ret)
        __OSS__.setBucket("gdza").setKey(ret.URL).download2(ret.FileName,data=>{
          typeof callback==="function"&&callback(data)
        })
      })
    },
    goHistory(){
      const that=this;
      that.mainObj.history_house_id=that.from_data.house_id;
      that.mainObj.history_house_name=that.from_data.house_name;
      setTimeout(function () {
        that.setComponents('CustomerRentHistory');
      },200);
    },
    // toSaleCarryOver(){
    //   const that=this;
    //   if(!that.from_data.customer_id){
    //     that.$message.error("无业主")
    //   }
    //   if(!that.from_data.rent_customer_id){
    //     that.$message.error("请选择对象")
    //   }
    //   that.mainObj.now_customer_id=that.from_data.customer_id;
    //   that.mainObj.new_customer_id=that.from_data.rent_customer_id;
    //   that.mainObj.house_id=that.from_data.house_id;
    //   that.setComponents("SaleCarryOver");
    // }
  }
}
</script>

<style lang="scss" scoped>
.content{

}
</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/components/CustomerRentEditor.vue